export const GET_HAS_DOMICILIATION = "GET_HAS_DOMICILIATION";
export const GET_HAS_DOMICILIATION_SUCCESS = "GET_HAS_DOMICILIATION_SUCCESS";
export const GET_HAS_DOMICILIATION_ERROR = "GET_HAS_DOMICILIATION_ERROR";
export const GET_MESSAGES_DOMICILIATION = "GET_MESSAGES_DOMICILIATION";
export const DOMICILIATION_REFERENCE = "DOMICILIATION_REFERENCE";
export const DOMICILIATION_REFERENCE_SUCCESS =
  "DOMICILIATION_REFERENCE_SUCCESS";
export const DOMICILIATION_REFERENCE_ERROR = "DOMICILIATION_REFERENCE_ERROR";
export const SET_DOMICILIATION_REFERENCE_VALUES =
  "SET_DOMICILIATION_REFERENCE_VALUES";
export const CAN_CALL_NIP = "CAN_CALL_NIP";
export const CAN_UPSELL_N2 = "CAN_UPSELL_N2";
export const SET_GO_TO_DOMICILIATION_FORM = "SET_GO_TO_DOMICILIATION_FORM";
export const SET_DATE_FROM_NATIVE_DATE_PICKER = "SET_DATE_FROM_NATIVE_DATE_PICKER";
export const SET_FROM_ACTION_VALUE = "SET_FROM_ACTION_VALUE";
export const SET_TERMS_CHECKBOX = "SET_TERMS_CHECKBOX";
export const SET_MAX_AMOUNT_VALUE = "SET_MAX_AMOUNT_VALUE";

export const getHasDomiciliation = (reference, serviceId) => ({
  type: GET_HAS_DOMICILIATION,
  reference,
  serviceId,
});

export const getHasDomiciliationSuccess = (
  hasDomiciliationServiceResponseSuccess
) => ({
  type: GET_HAS_DOMICILIATION_SUCCESS,
  hasDomiciliationServiceResponseSuccess,
});

export const getHasDomiciliationError = (error) => ({
  type: GET_HAS_DOMICILIATION_ERROR,
  hasDomiciliationServiceResponseError: error,
});

export const getMessagesDomiciliationSuccess = (messagesDomiciliation) => ({
  type: GET_MESSAGES_DOMICILIATION,
  messagesDomiciliation,
});

export const domiciliationReference = (encodedPin) => ({
  type: DOMICILIATION_REFERENCE,
  encodedPin,
});

export const domiciliationReferenceSuccess = (
  domiciliationReferenceResponse
) => ({
  type: DOMICILIATION_REFERENCE_SUCCESS,
  domiciliationReferenceResponse,
});

export const domiciliationReferenceError = (error) => ({
  type: DOMICILIATION_REFERENCE_ERROR,
  domiciliationReferenceResponseError: error,
});

export const setDomiciliationReferenceValues = (
  reference,
  expirationDate,
  amountValue,
  tcValue
) => ({
  type: SET_DOMICILIATION_REFERENCE_VALUES,
  reference,
  expirationDate,
  amountValue,
  tcValue,
});

export const setFromActionValue = (action) => {
return {
  type: SET_FROM_ACTION_VALUE,
  payload : action
};
}

export const setTermsCheckboxValue = (isChecked) => ({
  type: SET_TERMS_CHECKBOX,
  payload: isChecked,
});

export const setMaxAmountValue = (action) => ({
  type: SET_MAX_AMOUNT_VALUE,
  payload : action
});
